import React, { useState } from 'react';
import { CollapseArrow } from '~/assets/svg/InterfaceIcon';

const PreviewModalCard = ({question}) => {

    const [openToggle, setOpenToggle] = useState(false);

    return (
        <li className={`faq-item ${openToggle ? "" : "card-close"}`}>
            <button type="button" className="faq-item-header" onClick={() => setOpenToggle(!openToggle)}>
                <CollapseArrow />
                {question.question}
            </button>
            <div className="faq-answer">
                <p className="card-answer-line">{question.answer}</p>
            </div>
        </li>
    );
};

export default PreviewModalCard;